module.exports = __webpack_public_path__ + "static/media/skill-3.60f72554.svg";